import { render, staticRenderFns } from "./FormFieldsProfilePayment.vue?vue&type=template&id=456f0450&scoped=true&"
import script from "./FormFieldsProfilePayment.vue?vue&type=script&lang=js&"
export * from "./FormFieldsProfilePayment.vue?vue&type=script&lang=js&"
import style0 from "./FormFieldsProfilePayment.vue?vue&type=style&index=0&id=456f0450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456f0450",
  null
  
)

export default component.exports